
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appt/[id]",
      function () {
        return require("private-next-pages/appt/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/appt/[id]"])
      });
    }
  